import { api, ApiRequestConfig } from '../api';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type TApiMethod = (path: string, data: {}, config?: ApiRequestConfig) => Promise<any>;

export type TApi = {
  get: TApiMethod;
  post: TApiMethod;
  put: TApiMethod;
  patch: TApiMethod;
};

export function post<Response = {}, Data extends {} = {}>(host: string, apiKey: string) {
  return (path: string, data: Data, config?: ApiRequestConfig) =>
    doRequest<Response, Data>('post', path, data, host, apiKey, config);
}

export function get<Response = unknown, Data extends {} = {}>(host: string, apiKey: string) {
  return (path: string, data: Data, config?: ApiRequestConfig) =>
    doRequest<Response, Data>('get', path, data, host, apiKey, config);
}

export function put<Response = {}, Data extends {} = {}>(host: string, apiKey: string) {
  return (path: string, data: Data, config?: ApiRequestConfig) =>
    doRequest<Response, Data>('put', path, data, host, apiKey, config);
}

export function patch<Response = {}, Data extends {} = {}>(host: string, apiKey: string) {
  return (path: string, data: Data, config?: ApiRequestConfig) =>
    doRequest<Response, Data>('patch', path, data, host, apiKey, config);
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function doRequest<Response, Data extends {}>(
  method: 'get' | 'post' | 'put' | 'patch',
  path: string,
  data: Data,
  host: string,
  apiKey: string,
  config: ApiRequestConfig = {}
) {
  const apiMethod = api[method];
  if (apiKey) {
    config.headers = { ...config.headers, 'x-api-key': apiKey };
  }
  return apiMethod(buildUrl(host, path), data, config);
}

export const createApi = (host: string, apiKey: string) => ({
  get: get(host, apiKey),
  post: post(host, apiKey),
  put: put(host, apiKey),
  patch: patch(host, apiKey),
});

function buildUrl(base: string, part: string) {
  return new URL(`${base}${part}`).toString();
}
